<template>
  <div >
    <p @click="handle" class="content-list-title" :class = "{'readed-active' : data.read === '1'}">
      <img v-if="data.topStatus && data.topStatus === '1'" class="topIcon keep-hue" :src="require('@/assets/NewsCenter/topstatus.png')" alt="">
      <span class="title oneRowEllipsis">{{data.title || '-'}}</span>
      <img  class="new keep-hue"  v-if="data.isNewNews"  :src="require('@/assets/Home/Index/NewsIndex/newNews.png')">
    </p>


    <ListFoot style="margin-top: 13px" :data="data"/>
  </div>
</template>

<script>
  import ListFoot from "./listFoot";
  // v-if="data.topStatus && data.topStatus === '1'"
  export default {
    name: "SimpleNewsItem",
    data(){
      return {

      }
    },
    created(){

    },
    props: {
      data: { type: Object, default: () => []}
    },
    components: {
      ListFoot
    },
    methods: {
      handle() {
        // 点击设置已读状态
        if(this.data.read !== '1') this.$set(this.data,'read','1');

      }
    }
  }
</script>

<style scoped lang="scss" >
  @import "@/styles/variables.scss";
  .content-list-title {
    color:#111111;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    font-weight: bold;
    display: flex;
    align-items: center;
    &.readed-active {
      .title {
        color: #666666;
        &:hover {
          color: $color-primary;
          cursor: pointer;
        }
      }
    }

    img {
      width: 30px;
      height: 16px;
      margin-right: 10px;
    }
    .new {
      width: 30px;
      height: 16px;
      margin-left: 10px;
    }
    .title {
      flex:1
    }
    &-readed {
      color: #aaaaaa;
    }
    &:hover {
      color: $color-primary;
      cursor: pointer;
    }
    .topIcon {
      color: red;
      font-size: 1.5em;
      margin-right: 6px;
    }

  }
  @media (max-width: 1719px){
    .content-list-title {
      font-size: 16px;
    }

  }

</style>